import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to indicate loading state.
 */
var LoaderComponent = /** @class */ (function (_super) {
    __extends(LoaderComponent, _super);
    function LoaderComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderComponent = __decorate([
        Component({
            name: 'ui-loader',
        })
    ], LoaderComponent);
    return LoaderComponent;
}(Mixins(MagicConfigMixin)));

export default LoaderComponent;
